import React, { useState } from "react";
import { Menubar } from "primereact/menubar";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { getUniqueCategories, getUniqueBrands } from "../../services/productsService";
import { useEffect } from "react";
import logo from "../../assets/images/angelvariuslogo.png";
import "./MenuBar.css";

export default function MenuBar() {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    try {
      getUniqueCategories().then((categories) => {
        setCategories(categories.result);
      });
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  }, []);

  useEffect(() => {
    try {
      getUniqueBrands().then((brands) => {
        setBrands(brands.result);
      });
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  }, []);

  const navigate = useNavigate();
  const [searchFocused, setSearchFocused] = useState(false);

  // Simplificamos el renderer para que sea más limpio y accesible
  const itemRenderer = (item) => (
    <div className="nav-item" onClick={item.command}>
      <span className={`nav-item-icon ${item.icon}`} />
      <span className="nav-item-label">{item.label}</span>
    </div>
  );

  const items = [
    {
      label: "Home",
      icon: "pi pi-home",
      template: itemRenderer,
      command: () => navigate("/"),
    },
    {
      label: "Catalogo",
      icon: "pi pi-shop",
      template: itemRenderer,
      command: () => navigate("/shop"),
    },
    {
      label: "Novedades",
      icon: "pi pi-star",
      template: itemRenderer,
      command: () => navigate("/shop?novelty=true"),
    },
    {
      label: "Ofertas",
      icon: "pi pi-tag",
      template: itemRenderer,
      command: () => navigate("/shop?sales=true"),
    },
    {
      label: "Categorias",
      icon: "pi pi-list",
      template: itemRenderer,
      items: [
        ...categories.map((category) => ({
          label: category.category_name,
          icon: "pi pi-tag",
          template: itemRenderer,
          command: () => navigate("/shop?category=" + category.category_name),
        })),
      ],
    },
    {
      label: "Marcas",
      icon: "pi pi-tags",
      template: itemRenderer,
      items: [
        ...brands.map((brand) => ({
          label: brand.brand_name,
          icon: "pi pi-tag",
          template: itemRenderer,
          command: () => navigate("/shop?brand=" + brand.brand_name),
        })),
      ],
    },
    {
      label: "Nosotros",
      icon: "pi pi-users",
      template: itemRenderer,
      items: [
        {
          label: "Sobre Nosotros",
          icon: "pi pi-users",
          template: itemRenderer,
          command: () => navigate("/about"),
        },
        {
          label: "Contacto",
          icon: "pi pi-phone",
          template: itemRenderer,
          command: () => navigate("/contact"),
        },
        {
          label: "Envios",
          icon: "pi pi-truck",
          template: itemRenderer,
          command: () => navigate("/shipping"),
        }
      ]
    },
  ];

  const start = (
    <div className="nav-logo-wrap" onClick={() => navigate("/")}>
      <img alt="Angel Varius Logo" src={logo} className="nav-logo" />
    </div>
  );

  const end = (
    <div className="nav-end">
      <div className={`nav-search-wrap ${searchFocused ? "focused" : ""}`}>
        <i className="pi pi-search nav-search-icon" />
        <InputText
          placeholder="Buscar figuras..."
          className="nav-search-input"
          onFocus={() => setSearchFocused(true)}
          onBlur={() => setSearchFocused(false)}
          onKeyPress={(event) =>
            event.key === "Enter" &&
            navigate("/shop/?name=" + event.target.value)
          }
        />
      </div>
      {/* <button className="nav-icon-btn" aria-label="Favoritos">
        <i className="pi pi-heart" />
      </button>
      <button className="nav-icon-btn nav-cart-btn" aria-label="Carrito">
        <i className="pi pi-shopping-bag" />
        <span className="nav-cart-badge">3</span>
      </button> */}
    </div>
  );

  return (
    <header className="site-header">
      <Menubar model={items} start={start} end={end} className="site-menubar" />
    </header>
  );
}
